//import config from '../config'

let state = {

    response: {},	// объект ответа от БЕ в чистом виде
    session: {},	// данные текущей сессии
    common: {},			// общие для всех страниц
    page: {},			// индивидуальные для каждой страницы
    currentPage: {},	// текущая страница
    isLoading: false,

    // глобальные параметры UI
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
    isHeaderInversed: false,
    headerHeight: 64,
    withBurgerMenu: false,
    withBasketPopup: false,

    isBasketChangeCityPopupOpen: false,
    isSelectCityPopupOpen: false,
    cityId: null,
    cityName: null,

    destinations: null,

    // главное меню
    menuItems: [
        {
            name: "Онлайн-магазин",
            to: {name:"home-shop"},
            dropdown: [
                {
                    name: 'Пралине',
                    to: 'shop/original-pralines'
                },
                {
                    name: 'Мини-пралине',
                    to: 'shop/mini-pralines'
                },
                {
                    name: 'Ириски',
                    to: 'shop/creamy-caramels'
                },
                {
                    name: 'Шоколад ',
                    to: 'shop/chocolate-tablets'
                },
                {
                    name: 'Маленьким ангелам',
                    to: 'shop/kids'
                },
                {
                    name: 'Аксессуары',
                    to: 'shop/accessory'
                },
                {
                    name: 'Трюфели',
                    to: 'shop/truffles'
                },
                {
                    name: 'Домашние конфеты',
                    to: 'shop/domashnie-konfety'
                },
                {
                    name: 'Макарони',
                    to: 'shop/makaroni'
                },
                {
                    name: 'Печенье',
                    to: 'shop/pechene'
                },
                {
                    name: 'Торты',
                    to: 'shop/torty'
                },
                {
                    name: 'Подарки',
                    to: 'shop/podarochnye-nabory'
                }
            ],
            id: "shop",
            metrikaGoal: "clickOnlineStore",
        },
        {name: "Мы создаем", to: {name:"home-flavours"}, id: "flavours", metrikaGoal: "clickWeCreate"},
        {name: "Мы", to: {name:"home-story"}, id: "story"},
        {name: "Корпоративные подарки", to: {name:"corporate-gifts"}},
        //{name: "Souvenirs", to: {name:"category", params: {code:"souvenirs"}}},
        //{name: "Special occasion", to: {name:"home-special"}},
        //{name: "Our stores", to: {name:"home-stores"}},
        {name: "Где нас купить", to: {name:"places"}},
        {name: "Контакты", to: {name:"home-contacts"}, id: "contacts"},
        //{name: "Доставка", to: {name:"home-contacts"}},
        //{name: "Terms of sale", to: {name:"terms"}},
    ],
    selectedMenuItemId: null,

    // настройки языка
    currentLanguageCode: "EN",
    languages: [
        {
            code: "EN",
            name: "English language",
        },
        {
            code: "FR",
            name: "Française",
        }
    ],



    // todo reconsider all below =====

    // todo do we still need this
    swipers: {
        // todo fill correct keys
        /*'collection-slider': null,
        'ambassadors-slider-sm': null,
        'ambassadors-slider-lg': null*/
    },

    isPopupFlavours: false,
    myBoxImages: [
        require('@/assets/box/plus.svg'),
        require('@/assets/box/plus.svg'),
        require('@/assets/box/plus.svg'),
        require('@/assets/box/plus.svg'),
        require('@/assets/box/plus.svg'),
        require('@/assets/box/plus.svg'),
        require('@/assets/box/plus.svg'),
        require('@/assets/box/plus.svg'),
        require('@/assets/box/plus.svg')
    ],

    // баннер мини-опроса (см. mixins/survey-banner.js):
    // закрыт навсегда на внутренних страницах (ключ = SURVEY_CLOSED_STORAGE_KEY)
    isSurveyBannerClosed: (() => {
        try {
            return !!localStorage.getItem('isBannerLineSurveyClosed');
        } catch (e) {
            return false;
        }
    })(),
    // временно скрыт на главной (до ухода с неё)
    isSurveyBannerHidden: false,

    // промо-баннер над шапкой (см. mixins/promo-banner.js):
    // ключ баннера, который посетитель закрыл навсегда на внутренних страницах (ключ localStorage = PROMO_CLOSED_STORAGE_KEY)
    promoBannerClosedKey: (() => {
        try {
            return localStorage.getItem('isBannerLinePromoClosed');
        } catch (e) {
            return null;
        }
    })(),
    // временно скрыт на главной (до ухода с неё)
    isPromoBannerHidden: false,

};

export default state;
